module.exports = "/_next/static/images/da0b9564eb15db61004754027df18e91-girl-holding-card@xs.jpg";